import type { IconProps } from '../types/IconProps.ts';
export const LayoutPanelLeft: IconProps = {
    name: 'LayoutPanelLeft',
    children: [
        `<path d="M20 3h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M20 14h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1" />`,
        `<rect width="7" height="18" x="3" y="3" rx="1" />`,
    ]
};